<section class="forecast greyhounds-forecast">
    <section class="forecast-list greyhound-forecast-list">
        <ul>
            @if (isGreyhounds) {
                <ms-racingpost-pick
                    [fixture]="fixture"
                    [tab]="tab"
                    [optionGroup]="optionGroup"
                    [participantOptionGroups]="participantOptionGroups"
                    [isracingpostPickDisabled]="isracingpostPickDisabled"
                    [isGreyhounds]="true"
                    [isSports]="true"
                    (racingPostPicks)="racingpostpicks($event)" />
            }
            @if (!isGreyhounds && hasTimeFormRatings(fixture)) {
                <ms-timeform-pick
                    [fixture]="fixture"
                    [tab]="mode"
                    [optionGroup]="optionGroup"
                    [participantOptionGroups]="participantOptionGroups"
                    [isracingpostPickDisabled]="isracingpostPickDisabled" />
            }
            @for (model of forecastModel; let mIndex = $index; track mIndex) {
                <li class="clearfix" [ngClass]="{ flexbox: !isGreyhounds }">
                    @if (isGreyhounds) {
                        <div class="horse-name-group display-flx" [class.highlight]="participantHighlight(model)">
                            <ms-gh-trap-images
                                [greyhoundTrapDogMapping]="greyhoundTrapDogMapping"
                                [isOptionBet]="isOptionBet"
                                [participant]="model.participant" />
                            <span
                                class="dog-name"
                                [ngClass]="model.first || model.second || model.third || model.any ? 'fnt-wght-700' : 'fnt-wght-400'">
                                @if (isOptionBet) {
                                    {{ this.greyhoundTrapDogMapping[model.participant.participantId].greyhoundName }}
                                } @else {
                                    {{ model.participant.properties!.greyhound || (model.participant.name | msTranslate) }}
                                }
                            </span>
                        </div>
                    } @else {
                        <div class="horses-name-group">
                            <div class="horse-info-numbers">
                                @if (model.participant.properties?.raceCardNumber) {
                                    <span class="saddle-number" [class.highlight]="participantHighlight(model)">
                                        {{ model.participant.properties?.raceCardNumber }}
                                    </span>
                                }
                                @if (model.participant.properties?.drawNumber) {
                                    <span class="runner-draw-number"> ({{ model.participant.properties?.drawNumber }}) </span>
                                }
                            </div>
                            @if (model.participant.timeformInfo) {
                                <ms-horses-silk
                                    [src]="model.participant.timeformInfo.silkUrl"
                                    [description]="model.participant.timeformInfo.silkDescription" />
                            }
                            <span class="horse-name" [class.highlight]="participantHighlight(model)">{{ model.participant.name | msTranslate }}</span>
                        </div>
                    }

                    @if (!isMarketSuspended && !priceStatusSuspended(model.option)) {
                        <div class="place-pickers">
                            @for (column of forecastColumns; let cIndex = $index; track cIndex) {
                                @if (column.visible) {
                                    <div class="input-group">
                                        <input
                                            class="ms-checkbox filled"
                                            type="checkbox"
                                            [id]="model.checkboxId[column.id]"
                                            [disabled]="isPlaceColumnDisabled(model, column.id)"
                                            [ngModel]="forecastModel[mIndex][column.id]"
                                            (ngModelChange)="onForecastChange($event, mIndex, column.id)" />
                                        <label [for]="model.checkboxId[column.id]"></label>
                                        <div class="picker-title">{{ column.name }}</div>
                                    </div>
                                }
                            }
                            <div class="input-group">
                                <input
                                    class="ms-checkbox filled"
                                    type="checkbox"
                                    [id]="model.checkboxId.any"
                                    [disabled]="isAnyColumnDisabled()"
                                    [ngModel]="forecastModel[mIndex].any"
                                    (ngModelChange)="onAnyColumnChange($event, mIndex, 'any')" />

                                <label [for]="model.checkboxId.any"></label>
                                <div class="picker-title" [msWhenOverflowed]="{ classNameToAdd: 'font-resize' }">
                                    {{ anyMessageForGreyhounds }}
                                </div>
                            </div>
                        </div>
                    }
                    <ng-container>
                        @if (isMarketSuspended || priceStatusSuspended(model.option)) {
                            <div class="place-pickers">
                                @for (column of forecastColumns; let cIndex = $index; track cIndex) {
                                    <ng-container>
                                        @if (column.visible) {
                                            <div class="input-group-locked"><i class="theme-locked-i"></i></div>
                                        }
                                    </ng-container>
                                }
                                <div class="input-group-locked"><i class="theme-locked-i"></i></div>
                            </div>
                        }
                    </ng-container>
                </li>
            }
        </ul>
    </section>

    <section class="clearfix" [ngClass]="isGreyhounds ? 'greyhound-forecast-buttons' : 'forecast-buttons'">
        <div class="info-message-box clearfix" [ngSwitch]="validPick()">
            @switch (validPick()) {
                @case (false) {
                    <span class="info-message">{{ getInfoMessage() }}</span>
                }
                @case (true) {
                    <span class="info-message highlight">{{ getPickSummary() }}</span>
                }
            }
        </div>
        <div class="input-group clearfix">
            <button
                class="forecast-button"
                ds-button
                kind="secondary"
                variant="filled"
                size="large"
                [disabled]="!canClearPicks()"
                (click)="clearPicks()">
                {{ this.sitecore.horseRacing.raceDetails.Clear }}
            </button>
            <button class="forecast-button" ds-button kind="primary" variant="filled" size="large" [disabled]="!validPick()" (click)="betslipAdd()">
                {{ this.sitecore.horseRacing.raceDetails.AddToBetslip }}
            </button>
        </div>
    </section>
</section>
